import React from 'react';

import { Radio } from 'antd';

import { getIn } from 'formik';
import type { FieldProps } from 'formik';
import { Hint } from 'v2/components/Shared/Hint';

interface IOption {
  label: string;
  value: string;
}

interface IProps extends FieldProps {
  label?: string;
  formStyle?: any;
  formControlStyle?: any;
  options: IOption[];
  row?: boolean;
}

export const ListRadioButtonFormField = ({ field, form, label, options, formStyle, formControlStyle, row }: IProps) => {
  const errorText = getIn(form.errors, field.name);

  return (
    <div className='w-full'>
      <Hint inputName={field.name}>
        {label && <label className='mb-1 block text-[15px]'>{label}</label>}
        <Radio.Group
          value={field.value}
          onChange={e => form.setFieldValue(field.name, e.target.value)}
          style={formStyle}
          className={row ? 'flex flex-row flex-wrap gap-2' : ''}
        >
          {options.map(op => (
            <Radio key={op.value} value={op.value} style={formControlStyle} className='text-[15px]'>
              {op.label}
            </Radio>
          ))}
        </Radio.Group>
      </Hint>
      {errorText && <p className='mt-1 text-xs text-red-500'>{errorText}</p>}
    </div>
  );
};
